/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_No_Commits_ConfirmInputs */

const en_team_share_no_commits_confirm = /** @type {(inputs: Team_Share_No_Commits_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const fr_team_share_no_commits_confirm = /** @type {(inputs: Team_Share_No_Commits_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const de_team_share_no_commits_confirm = /** @type {(inputs: Team_Share_No_Commits_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const it_team_share_no_commits_confirm = /** @type {(inputs: Team_Share_No_Commits_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ru_team_share_no_commits_confirm = /** @type {(inputs: Team_Share_No_Commits_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ХОРОШО`)
};

const es_team_share_no_commits_confirm = /** @type {(inputs: Team_Share_No_Commits_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DE ACUERDO`)
};

const zh_cn2_team_share_no_commits_confirm = /** @type {(inputs: Team_Share_No_Commits_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`好的`)
};

const ja_team_share_no_commits_confirm = /** @type {(inputs: Team_Share_No_Commits_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`わかりました`)
};

const hi_team_share_no_commits_confirm = /** @type {(inputs: Team_Share_No_Commits_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठीक है`)
};

const pt_pt2_team_share_no_commits_confirm = /** @type {(inputs: Team_Share_No_Commits_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

/**
* | output |
* | --- |
* | "OK" |
*
* @param {Team_Share_No_Commits_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_no_commits_confirm = /** @type {((inputs?: Team_Share_No_Commits_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_No_Commits_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_no_commits_confirm(inputs)
	if (locale === "de") return de_team_share_no_commits_confirm(inputs)
	if (locale === "it") return it_team_share_no_commits_confirm(inputs)
	if (locale === "ru") return ru_team_share_no_commits_confirm(inputs)
	if (locale === "es") return es_team_share_no_commits_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_no_commits_confirm(inputs)
	if (locale === "ja") return ja_team_share_no_commits_confirm(inputs)
	if (locale === "hi") return hi_team_share_no_commits_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_no_commits_confirm(inputs)
	return en_team_share_no_commits_confirm(inputs)
});